import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "@/view/worldCup2026/components/ActivityRules";
import {Toast} from "antd-mobile";
import Service from "../service";
import {hideLoading, showLoading} from "@/components/loading";
import MyCollectionsModal from "@/view/worldCup2026/components/MyCollectionsModal";

/**
 * @description 2026世界杯
 * @return {/worldCup2026/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]

const CupItems = [
  { key: 'a' },
  { key: 'b' },
  { key: 'c' },
  { key: 'd' },
  { key: 'e' },
  { key: 'f' },
  { key: 'g' },
  { key: 'h' },
  { key: 'i' },
  { key: 'j' },
  { key: 'k' },
  { key: 'l' },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});

  useEffect(() => {
    (()=>{
      getData(true)
      onDidFocus()
    })()

  }, [])
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus()
    });
  }
  const getData = async (loading = false) => {
    try {
      if (loading) showLoading()
      if (loading) {
        const userInfoRes = await Service.getUserCertificateStatus()
        setUserInfo(userInfoRes)
      }
      const res = await Service.getInitData()
      if (loading) hideLoading()
      if (res.code !== '000000') throw res.msg
      setData(res.data)
    } catch (error) {
      hideLoading()
      Toast.show(error)
    }
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }

  const openCollectionModal = () => {
    const ModalInstance = NFTModal.show({
      content: <MyCollectionsModal onClose={() => ModalInstance?.close()} data={data?.teams}/>,
      getContainer: pageDom.current,
    })
  }

  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data])
  const buyHandle = (key) => {
    const activityCode = data?.groups?.[key]
    if (!activityCode) {
      Toast.show("活动不存在");
      return;
    }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    // const e = 'https://nfth5-test.greenlandgk.cn/nftPad/saleDetail?activityCode=MH202604290001'
    const uri = `/nftPad/saleDetail?activityCode=${activityCode}`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      })
    } else {
      navigate(uri)
    }
  }

  return (
    <div className={Styles.worldCupHome} ref={pageDom}>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <button className={Styles.myCollectionCard} onClick={openCollectionModal}>我的藏品</button>
      <div className={Styles.rightCard}/>
      <div className={Styles.content}>
        {CupItems.map((item, index) => {
          return (
            <div className={`${Styles.card} ${Styles[item.key]}`} key={index} onClick={() => buyHandle(item.key)}>
            </div>
          )
        })}
        <div className={Styles.logo} />
      </div>
    </div>
  )
}
export default Home